import React from 'react';

function BrewmasterMessage({ role, content, children }) {
  const isBrewmaster = role === 'brewmaster';

  return (
    <div className={`flex ${isBrewmaster ? 'justify-start' : 'justify-end'} mb-4`}>
      <div className={`max-w-[85%] rounded-lg px-4 py-3 ${
        isBrewmaster
          ? 'bg-gray-800 border border-gray-700 text-gray-200'
          : 'bg-purple-900/40 border border-purple-700 text-gray-200'
      }`}>
        {isBrewmaster && (
          <p className="text-xs text-amber-400 font-semibold mb-1">Brewmaster</p>
        )}
        {content && <p className="text-sm whitespace-pre-wrap">{content}</p>}
        {children}
      </div>
    </div>
  );
}

export default BrewmasterMessage;
